export const searchInObj = {
  all: "inbox-all-title",
  sent: "inbox-sent-title",
  received: "inbox-received-title",
  trash: "inbox-trash-title",
  picker: "JUMBOpicker",
};

export const filterInObj = {
  jform: "JUMBOforms",
  jmail: "JUMBOmail",
  jpicker: "JUMBOpicker",
  jpay: "JUMBOpay",
};

export const inboxSoringOptions = {
  date: "inbox-date-sorting",
  size: "inbox-size-sorting",
  number: "inbox-filesnumber-sorting",
  // name: "inbox-name-sorting",
  downloadsQuantity: "inbox-downloads-sorting",
};

export const selectOptionsList = {
  all: "inbox-select-all",
  pendingDownload: "inbox-select-pending",
  downloaded: "inbox-select-downloaded",
  aboutToExpire: "inbox-select-abouttoexpire",
  jumbopay: "inbox-select-jumbopay",
  saved: "inbox-select-saved",
  secured: "inbox-select-secured",
};

export const sidebarMenu = {
  sent: {
    icon: { name: "reply" },
    viewNameKey: "inbox-sent-title",
    innerList: [
      { value: "active", title: "inbox-active-title" },
      { value: "saved", title: "inbox-saved-title" },
      { value: "archived", title: "inbox-archived-title" },
    ],
  },
  received: {
    icon: { name: "reply", prop: { horInvert: true } },
    viewNameKey: "inbox-received-title",
    innerList: [
      { value: "active", title: "inbox-active-title" },
      { value: "saved", title: "inbox-saved-title" },
      { value: "archived", title: "inbox-archived-title" },
    ],
  },
  forms: {
    icon: { name: "jform-black" },
    viewNameKey: "inbox-forms-title",
    innerList: [
      { value: "received", title: "inbox-forms-received-title" },
      { value: "saved", title: "inbox-forms-saved-title" },
      { value: "archived", title: "inbox-forms-archived-title" },
    ],
  },
  // contacts: {
  //   icon: { name: "contact-react-list" },
  //   viewNameKey: "inbox-contacts-title",
  // },
};

export const newSidebarMenu = {
  all: {
    icon: { name: "newInbox/all" },
    viewNameKey: "inbox-all-title",
  },
  sent: {
    icon: { name: "newInbox/outbox" },
    viewNameKey: "inbox-sent-title",
  },
  received: {
    icon: { name: "newInbox/inbox" },
    viewNameKey: "inbox-received-title",
  },
  trash: {
    icon: { name: "newInbox/trash" },
    viewNameKey: "inbox-trash-title",
  },
  // picker: {
  //   icon: { name: "newInbox/Products/picker" },
  //   viewNameKey: "JUMBOpicker",
  // },
};

export const sidebarFiltersMenu = {
  jmail: {
    icon: { name: "newInbox/Products/mail" },
    name: "JUMBOmail",
  },
  jform: {
    icon: { name: "newInbox/Products/forms" },
    name: "JUMBOforms",
  },
  jpay: {
    icon: { name: "newInbox/Products/pay" },
    name: "JUMBOpay",
  },
  picker: {
    icon: { name: "newInbox/Products/picker" },
    name: "JUMBOpicker",
  },
};

export const removeStatuses = ["pendingRemoved", "removed"];

export const formStatusColorsObj = {
  orderCreated: "rgb(4, 82, 129)",
  uploading: "rgb(10, 130, 197)",
  sent: "rgb(45, 174, 184)",
  downloaded: "rgb(158, 193, 38)",
  pendingRemoved: "rgb(251, 174, 0)",
  removed: "rgb(244, 99, 11)",
  error: "rgb(233, 18, 86)",
  uploadingError: "rgb(189, 18, 136)",
  custom1: "#F24812",
  custom2: "#E6006D",
  custom3: "#B7148C",
  custom4: "#88148C",
  custom5: "#F79100",
};

export const sortedListOfStatuses = [
  "orderCreated",
  "uploading",
  "sent",
  "downloaded",
  "pendingRemoved",
  "removed",
  "error",
  "uploadingError",
];

export const labelColors = [
  "#E6E6E6",
  "#FFB7B7",
  "#FFC397",
  "#FFF389",
  "#D1F4A4",
  "#B9FFD5",
  "#BBE6F3",
  "#CDBBFF",
  "#FED8FF",
  "#FF8CA8",
  "#5C5C5C",
  "#CC2D2D",
  "#FF862F",
  "#F4D21A",
  "#70AB42",
  "#28947A",
  "#1E98B2",
  "#5B41A5",
  "#BF47C1",
  "#C2175F",
];

export const getMailStatuses = (t, filter) => {
  const pendingRemoved = {
    name: "pendingRemoved-mail-status-inbox",
    visibleFor: {
      trash: ["jmail", "jpay", "jform"],
    },
  };
  const removed = {
    name: "removed-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jmail", "jpay", "jform"],
      trash: ["jmail", "jpay", "jform"],
    },
  };
  const active = {
    name: "sent-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jmail", "jpay", "jform"],
    },
  };
  const saved = {
    name: "saved-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jform"],
    },
  };
  const uploading = {
    name: "uploading-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jmail", "jpay", "jform"],
    },
  };
  const mailStatuses = {
    all: {
      // saved,
      active,
      uploading,
      pendingRemoved,
      removed,
    },
    received: {
      // saved,
      active,
      uploading,
      pendingRemoved,
      removed,
    },
    sent: {
      // saved,
      active,
      uploading,
      removed,
    },
    trash: {
      pendingRemoved,
      removed,
    },
  };

  const selectedTypeMailStatuses = mailStatuses?.[t];

  const filteredMailStatuses = Object.keys(
    selectedTypeMailStatuses || mailStatuses.all
  )
    .filter((status) =>
      !filter || t === "all"
        ? true
        : selectedTypeMailStatuses[status].visibleFor[t || "sent"]?.includes(
            filter
          )
    )
    .filter((status) => status);

  return filteredMailStatuses;
};

export const trashStatuses = {
  pendingRemoved: {
    name: "pendingRemoved-mail-status-inbox",
    visibleFor: {
      trash: ["jmail", "jpay", "jform"],
    },
  },
  removed: {
    name: "removed-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jmail", "jpay", "jform"],
      trash: ["jmail", "jpay", "jform"],
    },
  },
};

export const mailStatuses = {
  active: {
    name: "sent-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jmail", "jpay", "jform"],
    },
  },
  saved: {
    name: "saved-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jform"],
    },
  },
  uploading: {
    name: "uploading-mail-status-inbox",
    visibleFor: {
      sent: ["jmail", "jpay"],
      received: ["jmail", "jpay", "jform"],
    },
  },
  ...trashStatuses,
};

export const actionStatuses = {
  jpay: {
    Paid: { name: "Paid-action-status" },
    NotPaid: { name: "NotPaid-action-status" },
  },
  jform: {
    PendingDownload: { name: "PendingDownload-action-status" },
    Downloaded: { name: "Downloaded-action-status" },
  },
  default: {
    Paid: { name: "Paid-action-status" },
    NotPaid: { name: "NotPaid-action-status" },
    PendingDownload: { name: "PendingDownload-action-status" },
    Downloaded: { name: "Downloaded-action-status" },
  },
};

export const actionStatusColors = {
  Paid: "#5F9FAD",
  NotPaid: "#9FBFC6",
  PendingDownload: "#CF70FB",
  Downloaded: "#12DEA1",
};

export const getActionsBasedOnMailType = (all, mailData, actionsList) => {
  if (!mailData || !actionsList) return [];
  if (!all || (mailData.isJForm && all))
    return actionsList.forms || actionsList;
  else if (all && mailData.mailStatus === "removed") {
    return actionsList;
  }
  if (all & !mailData.isOutbox) {
    return actionsList.received;
  }
  if (mailData.isJForm) return actionsList.forms;
  if (!mailData.isOutbox) return actionsList.received;
  return actionsList.sent;
};

export const getTruncatedText = (container, text) => {
  if (!container) return text;
  const charWidth = 22;
  const containerWidth = window.innerWidth / 2.2;
  const maxChars = Math.round(containerWidth / charWidth);
  const truncatedText = text.slice(0, maxChars) + "...";
  if (text.length > maxChars) return truncatedText;
  else return text;
};

const MAX_LABEL_NAME_LENGTH = 15;

export const sliceLabelName = (name) => {
  if (!name) return "";

  if (isLabelNameSliced(name)) {
    return name.slice(0, MAX_LABEL_NAME_LENGTH) + "...";
  }
  return name;
};

export const isLabelNameSliced = (name) => {
  return name?.length > MAX_LABEL_NAME_LENGTH;
};

export const hasLabelId = (labelIds, id) => {
  if (!labelIds?.length) return false;

  return labelIds.includes(id);
};

export const isBrightColor = (color) => {
  if (!color) return false;

  const lastBrightColorIndex = 8;
  // colors sorted in array by brightness so need to find last bright color
  const colorIndex = labelColors.findIndex(
    (labelColor) => labelColor === color
  );

  const customStatusColors = [
    "#F24812",
    "#E6006D",
    "#B7148C",
    "#88148C",
    "#F79100",
  ];

  const isCustomColor = customStatusColors.includes(color.toUpperCase());
  if (isCustomColor) return false;

  return colorIndex < lastBrightColorIndex;
};

export const getPickerProjectIdFromURL = (url) => {
  return url.match(/&idc=(.*?)&/)?.[1] || "";
};

export const getJFormStatus = (
  mailStatus,
  isEmbedManuallyDeleted,
  isSaved,
  downloadsQuantity,
  expirationDate
) => {
  const isMailSaved =
    (isEmbedManuallyDeleted && mailStatus !== "removed") || isSaved;
  const isNotExpired =
    new Date(expirationDate) - new Date() > 0 && mailStatus !== "removed";
  const wasDownloaded = downloadsQuantity > 0;

  if (mailStatus === "pendingRemoved" || mailStatus === "uploading") {
    return mailStatus;
  } else if (mailStatus === "orderCreated") {
    return "created";
  } else if (isMailSaved) {
    return "saved";
  } else if (mailStatus === "sent") {
    return "active";
  } else if (wasDownloaded) {
    if (isNotExpired) {
      return "active";
    } else {
      return "removed";
    }
  } else if (mailStatus !== "removed") {
    return "pendingDownload";
  } else {
    return mailStatus;
  }
};

export const getMailStatusTooltipTextValue = (
  status,
  isJForm,
  expirationDate,
  hoursLeft,
  daysLeft,
  codes,
  returnDate,
  returnTime,
  autoRemove,
  getTextByKey
) => {
  let tooltipTextValue;

  if (status === "active") {
    if (!expirationDate && !isJForm) {
      tooltipTextValue = getTextByKey(`tooltip-status-saved-by-another-inbox`);
    } else if (!expirationDate && isJForm) {
      tooltipTextValue = getTextByKey(`tooltip-status-saved-in-jform-settings`);
    } else if (hoursLeft < 24) {
      tooltipTextValue = getTextByKey(
        `tooltip-status-active-hours-inbox`
      ).replace("#number#", hoursLeft);
    } else if (codes) {
      tooltipTextValue = getTextByKey(`tooltip-status-saved-with-jmcode`)
        .replace("#number#", daysLeft)
        .replace("#jmcode#", codes.join(","));
    } else {
      tooltipTextValue = getTextByKey(
        `tooltip-status-active-days-inbox`
      ).replace("#number#", daysLeft);
    }
  } else if (status === "removed") {
    tooltipTextValue = `${getTextByKey(
      "tooltip-status-removed-inbox"
    )} at ${returnDate} ${returnTime}`;
  } else if (status === "pendingDownload") {
    tooltipTextValue = getTextByKey(
      `tooltip-status-pending_download-inbox`
    ).replace("#number#", autoRemove);
  } else if (status === "pendingRemoved") {
    tooltipTextValue = getTextByKey(`tooltip-status-pending_removed-inbox`);
  } else {
    tooltipTextValue = getTextByKey(`tooltip-status-${status}-inbox`);
  }
  return tooltipTextValue;
};

export const getAvailablePickerProjectsAmount = (isPro, isBusiness) => {
  if (isPro) return 1;
  if (isBusiness) return 15;
  return 0;
};

export const calcCounters = (mailData, currentUser) => {
  const counters = {
    sent: 0,
    received: 0,
    all: 0,
    trash: 0,
    jmail: 0,
    jform: 0,
    jpay: 0,
  };

  counters.all += 1;
  counters.trash -= 1;
  if (mailData.isJMail) {
    counters.jmail -= 1;
  }
  if (mailData.isJForm) {
    counters.jform -= 1;
  }
  if (mailData.isJPay) {
    counters.jpay -= 1;
  }

  // if is inbox
  if (mailData.SenderInfo?.senderEmail === currentUser.UserName) {
    counters.received += 1;
  } else {
    counters.sent += 1;
  }

  return counters;
};

export const showSaveAction = (mailData, pageType) => {
  if (
    !mailData ||
    (mailData.isJForm
      ? getJFormStatus(
          mailData.mailStatus,
          mailData.isEmbedManuallyDeleted,
          mailData.isSaved,
          mailData.downloadsQuantity,
          mailData.expirationDate
        ) === "saved"
      : false) ||
    mailData.isEmbedManuallyDeleted ||
    mailData.mailStatus === "saved" ||
    mailData.mailStatus === "removed" ||
    pageType === "trash" ||
    // It means sender removed mail and recipient can't save it
    (!mailData.isOutbox && mailData.mailStatus === "pendingRemoved") ||
    mailData.mailStatus === "uploading"
  ) {
    return false;
  } else {
    return true;
  }
};

export const showDeleteAction = (mailData, pageType) => {
  if (
    mailData.isSaved &&
    pageType !== "trash"
    // || mailData.mailStatus === "uploading"
  ) {
    return true;
  } else {
    return false;
  }
};
